export default "https://cdn-static.gokick.com/assets/ac547ee441cd23ce845c1e2810a666ddd08d044b/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";